import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  min-height: 100%;
  width: 100%;
}

.home-page {
  background: #f4f8f5;
  min-height: calc(100vh - 138px);
  overflow: hidden;
  width: 100%;
}

.home-page.is-leaving {
  animation: home-leave 180ms ease-in forwards;
}

.home-hero {
  align-items: center;
  background: #0c2825;
  display: flex;
  min-height: clamp(520px, 38vw, 620px);
  overflow: hidden;
  position: relative;
  width: 100%;
}

.home-hero__media {
  background-image: url("/assets/home-hero-architecture.png");
  background-position: center 48%;
  background-repeat: no-repeat;
  background-size: cover;
  inset: 0;
  position: absolute;
  transform: scale(1.01);
}

.home-hero__overlay {
  background: linear-gradient(90deg, rgba(5, 31, 29, 0.62) 0%, rgba(7, 40, 37, 0.46) 42%, rgba(7, 31, 30, 0.16) 72%, rgba(5, 23, 24, 0.08) 100%), linear-gradient(180deg, rgba(4, 19, 20, 0.03) 0%, rgba(4, 23, 22, 0.2) 100%);
  inset: 0;
  position: absolute;
}

.home-hero__content {
  animation: home-rise 720ms cubic-bezier(0.2, 0.72, 0.22, 1) both;
  color: #fff;
  margin: 0 auto;
  max-width: 1256px;
  padding: 72px 32px 68px;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 1;
}

.home-eyebrow {
  align-items: center;
  color: rgba(231, 245, 241, 0.76);
  display: inline-flex;
  font-size: 10px;
  font-weight: 750;
  gap: 11px;
  letter-spacing: 0.18em;
  margin-bottom: 28px;
}

.home-eyebrow__pulse {
  animation: pulse 2.2s ease-in-out infinite;
  background: #60dfaa;
  border-radius: 50%;
  box-shadow: 0 0 0 5px rgba(96, 223, 170, 0.12);
  height: 7px;
  width: 7px;
}

.home-eyebrow__line {
  background: rgba(230, 243, 240, 0.34);
  height: 1px;
  width: 28px;
}

.home-hero h1 {
  display: flex;
  flex-direction: column;
  font-size: clamp(48px, 4.6vw, 68px);
  font-weight: 780;
  letter-spacing: -0.055em;
  line-height: 1.08;
  margin: 0;
  text-shadow: 0 6px 30px rgba(0, 0, 0, 0.22);
}

.home-title-accent {
  color: #8cf0c1;
  margin-top: 4px;
}

.home-hero p {
  color: rgba(241, 248, 246, 0.86);
  font-size: clamp(14px, 1.2vw, 17px);
  font-weight: 520;
  line-height: 1.65;
  margin: 26px 0 0;
}

.home-hero__actions {
  align-items: center;
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-top: 34px;
}

.home-hero__primary,
.home-hero__secondary {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  font-weight: 750;
  gap: 14px;
  justify-content: center;
  min-height: 50px;
  text-decoration: none;
  transition: transform 220ms ease, box-shadow 220ms ease, background 220ms ease;
}

.home-hero__primary {
  background: #f1fbf6;
  border: 0;
  border-radius: 999px;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.16);
  color: #102e2a;
  padding: 0 10px 0 26px;
}

.home-hero__primary svg {
  background: #143a34;
  border-radius: 50%;
  color: #fff;
  height: 38px;
  padding: 10px;
  width: 38px;
}

.home-hero__secondary {
  border-bottom: 1px solid rgba(255, 255, 255, 0.48);
  color: #fff;
  padding: 0 0 3px;
}

.home-hero__secondary svg {
  height: 19px;
  width: 19px;
}

.home-hero__primary:hover,
.home-hero__secondary:hover {
  transform: translateY(-3px);
}

.home-hero__primary:hover {
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.24);
}

.home-hero__primary:focus-visible,
.home-hero__secondary:focus-visible,
.service-card:focus-visible {
  outline: 3px solid #79e2b3;
  outline-offset: 4px;
}

.home-services {
  background: #f4f8f5;
  padding: 24px 32px 34px;
  position: relative;
}

.home-services__grid {
  background-image: linear-gradient(rgba(16, 38, 35, 0.026) 1px, transparent 1px), linear-gradient(90deg, rgba(16, 38, 35, 0.026) 1px, transparent 1px);
  background-size: 62px 62px;
  inset: 0;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.35), transparent 74%);
  pointer-events: none;
  position: absolute;
}

.home-container {
  margin: 0 auto;
  max-width: 1256px;
  position: relative;
  width: 100%;
  z-index: 1;
}

.service-choice {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.service-card {
  animation: card-rise 720ms cubic-bezier(0.2, 0.72, 0.22, 1) both;
  border: 0;
  border-radius: 26px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  min-height: 284px;
  overflow: hidden;
  padding: 26px 28px 24px;
  position: relative;
  text-align: left;
  text-decoration: none;
  transition: box-shadow 260ms ease, transform 260ms ease;
}

.service-card::before {
  border: 1px solid currentColor;
  border-radius: 50%;
  content: "";
  height: 250px;
  opacity: 0.08;
  position: absolute;
  right: -92px;
  top: -116px;
  width: 250px;
}

.service-card::after {
  border: 1px solid currentColor;
  border-radius: 50%;
  content: "";
  height: 178px;
  opacity: 0.06;
  position: absolute;
  right: -54px;
  top: -80px;
  width: 178px;
}

.service-card--manage {
  animation-delay: 120ms;
  background: #ffffff;
  box-shadow: 0 16px 42px rgba(20, 56, 48, 0.08);
  color: #102623;
}

.service-card--market {
  animation-delay: 200ms;
  background: linear-gradient(145deg, #162b4d, #0b1930);
  box-shadow: 0 16px 42px rgba(8, 23, 46, 0.16);
  color: #ffffff;
}

.service-card:hover {
  box-shadow: 0 26px 60px rgba(16, 38, 35, 0.15);
  transform: translateY(-6px);
}

.service-card--market:hover {
  box-shadow: 0 28px 66px rgba(8, 23, 46, 0.26);
}

.service-card__number {
  font-size: 10px;
  font-weight: 750;
  left: 29px;
  letter-spacing: 0.16em;
  opacity: 0.48;
  position: absolute;
  top: 26px;
}

.service-card__topline {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  position: relative;
  width: calc(100% - 48px);
  z-index: 1;
}

.service-card__icon {
  align-items: center;
  background: #e7f4ec;
  border-radius: 16px;
  color: #0f6b5a;
  display: flex;
  height: 56px;
  justify-content: center;
  width: 56px;
}

.service-card--market .service-card__icon {
  background: rgba(255, 255, 255, 0.1);
  color: #c8dfef;
}

.service-card__icon svg {
  height: 31px;
  width: 31px;
}

.service-card__status {
  align-items: center;
  background: #f1f7f3;
  border-radius: 999px;
  color: #527068;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  gap: 7px;
  padding: 8px 11px;
}

.service-card__status > span {
  background: #3daf80;
  border-radius: 50%;
  height: 6px;
  width: 6px;
}

.service-card--market .service-card__status {
  background: rgba(255, 255, 255, 0.09);
  color: #d2deeb;
}

.service-card--market .service-card__status > span {
  background: #78c4eb;
}

.service-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 19px;
  position: relative;
  z-index: 1;
}

.service-card__label {
  color: #5a7c71;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.18em;
  margin-bottom: 6px;
}

.service-card--market .service-card__label {
  color: #93b3d0;
}

.service-card__body strong {
  font-size: clamp(27px, 2.4vw, 34px);
  font-weight: 760;
  letter-spacing: -0.04em;
  line-height: 1.15;
}

.service-card__body > span:last-child {
  color: #697a76;
  font-size: 13px;
  line-height: 1.62;
  margin-top: 10px;
}

.service-card--market .service-card__body > span:last-child {
  color: #afbed0;
}

.service-card__footer {
  align-items: center;
  border-top: 1px solid rgba(16, 38, 35, 0.1);
  display: flex;
  font-size: 12px;
  font-weight: 700;
  justify-content: space-between;
  margin-top: 19px;
  padding-top: 17px;
  position: relative;
  z-index: 1;
}

.service-card--market .service-card__footer {
  border-top-color: rgba(255, 255, 255, 0.12);
  color: #e9f1fa;
}

.service-card__arrow {
  align-items: center;
  background: #102623;
  border-radius: 50%;
  color: #fff;
  display: flex;
  height: 36px;
  justify-content: center;
  transition: transform 220ms ease;
  width: 36px;
}

.service-card--market .service-card__arrow {
  background: #edf7fc;
  color: #122747;
}

.service-card:hover .service-card__arrow {
  transform: translateX(4px);
}

.service-card__arrow svg {
  height: 19px;
  width: 19px;
}

.home-assurance {
  align-items: center;
  animation: home-rise 700ms 280ms cubic-bezier(0.2, 0.72, 0.22, 1) both;
  color: #6c7d78;
  display: flex;
  font-size: 11px;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 4px;
}

.home-assurance > div {
  align-items: center;
  display: flex;
  gap: 8px;
}

.home-assurance__icon {
  align-items: center;
  background: #e2f2e9;
  border-radius: 50%;
  color: #0f6b5a;
  display: flex;
  height: 22px;
  justify-content: center;
  width: 22px;
}

.home-assurance__icon svg {
  height: 14px;
  width: 14px;
}

.home-assurance__domain {
  font-size: 9px;
  font-weight: 750;
  letter-spacing: 0.16em;
}

@keyframes home-rise {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes card-rise {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes home-leave {
  to {
    opacity: 0;
    transform: translateY(-8px);
  }
}
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 5px rgba(96, 223, 170, 0.12);
  }
  50% {
    box-shadow: 0 0 0 9px rgba(96, 223, 170, 0.035);
  }
}
@media (max-width: 860px) {
  .home-hero {
    min-height: 560px;
  }
  .home-hero__content {
    padding-left: 22px;
    padding-right: 22px;
  }
  .home-services {
    padding-left: 22px;
    padding-right: 22px;
  }
  .service-choice {
    grid-template-columns: 1fr;
  }
  .service-card {
    min-height: 260px;
  }
}
@media (max-width: 640px) {
  .home-hero {
    align-items: flex-end;
    min-height: 590px;
  }
  .home-hero__media {
    background-position: 60% center;
  }
  .home-hero__overlay {
    background: linear-gradient(180deg, rgba(6, 28, 27, 0.22) 0%, rgba(5, 31, 29, 0.9) 66%, rgba(5, 25, 24, 0.96) 100%);
  }
  .home-hero__content {
    padding: 72px 18px 48px;
    text-align: left;
  }
  .home-eyebrow {
    gap: 8px;
    letter-spacing: 0.12em;
    margin-bottom: 18px;
  }
  .home-eyebrow__line,
  .home-eyebrow > span:last-child {
    display: none;
  }
  .home-hero h1 {
    font-size: clamp(32px, 8.8vw, 42px);
    letter-spacing: -0.045em;
  }
  .home-hero h1 span {
    min-width: 0;
    white-space: nowrap;
  }
  .home-hero p {
    font-size: 14px;
    line-height: 1.6;
    max-width: 330px;
  }
  .home-hero__actions {
    align-items: stretch;
    flex-direction: column;
    gap: 13px;
    margin-top: 28px;
  }
  .home-hero__primary {
    box-sizing: border-box;
    justify-content: space-between;
    max-width: 340px;
    width: 100%;
  }
  .home-hero__secondary {
    align-self: flex-start;
    min-height: 42px;
  }
  .home-services {
    padding: 18px 18px 28px;
  }
  .service-card {
    border-radius: 22px;
    min-height: 270px;
    padding: 23px 22px 21px;
  }
  .service-card__number {
    left: 23px;
    top: 24px;
  }
  .service-card__body > span:last-child br {
    display: none;
  }
  .home-assurance {
    align-items: flex-start;
    line-height: 1.5;
  }
  .home-assurance__domain {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .home-hero__content,
  .service-card,
  .home-assurance,
  .home-page.is-leaving {
    animation: none;
  }
  .home-hero__primary,
  .home-hero__secondary,
  .service-card {
    transition: none;
  }
}`],
})
export class PageHomeComponent implements OnInit {
    public leaving: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        document.title = '웅빈 미니홈';

        const root = document.querySelector('app-root') as HTMLElement;
        if (root) root.scrollTop = 0;

        await this.service.render();
    }

    public async openManagement() {
        if (this.leaving) return;
        this.leaving = true;
        await this.service.render();
        await this.service.sleep(160);
        this.service.href('/ip-management');
    }
}

export default PageHomeComponent;